// ステータス関連の定数定義
// 注: すべてのステータス定数は動的データに移行しました
// useReservationStatuses フックと statusMapper ユーティリティを使用してください
//
// 移行ガイド:
// - 車両ステータス: useReservationStatuses() から vehicleStatusList を取得
// - 予約ステータス: useReservationStatuses() から reservationStatusList を取得
// - 位置ステータス: useReservationStatuses() から locationStatusList を取得
// - ID/コード変換: statusMapper の getCodeById(), getIdByCode() を使用



// 連絡手段の配色設定
export const COMMUNICATION_MEDIA_COLORS = {
  TEL: { bg_color: '#FFD700', text_color: '#000000' }, // 黄色
  LINE: { bg_color: '#06C755', text_color: '#FFFFFF' }, // 緑 (LINEブランドカラー)
  SMS: { bg_color: '#1976D2', text_color: '#FFFFFF' }, // 青 (MUI Primary)
  WhatsApp: { bg_color: '#25D366', text_color: '#000000' }, // 緑 (WhatsAppブランドカラー)
  Instagram: { bg_color: '#C13584', text_color: '#FFFFFF' }, // 赤紫
  default: { bg_color: '#555555', text_color: '#FFFFFF' } // その他（濃いグレー）
} as const;
